import type { RuleSet } from 'styled-components';

import { css } from 'styled-components';

import { media } from '../core/styles';
import { SiteType } from '~/utilities/graphql/codegen';

const HeaderButtonStyles: Record<SiteType, RuleSet<object>> = {
  [SiteType.Aaf]: css`
    ${({ theme }) => css`
      padding: ${theme.padding.none} ${theme.padding['2xs']};

      &:hover,
      &:focus-visible {
        color: ${theme.colors.content.primary};
      }

      @media ${media(theme).greaterThan('sm')} {
        gap: ${theme.size[2]};
      }
    `}
  `,
  [SiteType.Employeeshop]: css``,
  [SiteType.Gstar]: css``,
  [SiteType.Outlet]: css``,
  [SiteType.Wahts]: css``,
};

export const HeaderButton = css`
  ${({ theme }) => css`
    height: var(--top-nav-height);
    text-decoration: none;
    display: flex;
    align-items: center;
    padding: ${theme.padding.none};
    gap: ${theme.size[1]};
    color: ${theme.colors.content.primary};

    &:hover,
    &:focus-visible {
      color: ${theme.components.button.primary.hover.backgroundColor};
    }

    ${HeaderButtonStyles[theme.siteType]}
  `}
`;
